export const tabs = [
    {
        path: "/availablevacation",
        className: "availablevacation",
        label: "Éves szabadságok"
    },
    {
        path: "/vacation",
        className: "vacation",
        label: "Szabadságok"
    },
    {
        path: "/vacationcalendar",
        className: "vacationcalendar",
        label: "Naptár"
    }
];